import React from 'react';
import { ArrowUpRight, Star, Sparkles } from 'lucide-react';

export default function Hero() {
  return (
    <section id="top" className="relative pt-32 md:pt-40 pb-16 md:pb-24">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        {/* Top strip */}
        <div className="flex items-center justify-between mb-8 md:mb-14">
          <div className="flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-[#162028]/60 font-medium">
            <span className="h-1.5 w-1.5 rounded-full bg-[#49001B] animate-pulse" />
            Since 2022 · Kochi, Kerala
          </div>
          <div className="hidden md:flex items-center gap-2 text-[12px] uppercase tracking-[0.22em] text-[#162028]/60 font-medium">
            <Sparkles size={13} className="text-[#49001B]" />
            Creative x Strategy x Cinema
          </div>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-8">
            <h1 className="font-serif-display text-[52px] sm:text-[72px] md:text-[92px] lg:text-[116px] leading-[0.94] tracking-[-0.02em] text-[#162028]">
              Your <span className="italic font-light">ultimate</span><br />
              <span className="marker-underline">Marketing</span> &amp;<br />
              <span className="italic font-light text-[#49001B]">Branding</span> companion<span className="text-[#49001B]">.</span>
            </h1>
          </div>
          <div className="lg:col-span-4 flex flex-col gap-6">
            <p className="text-[16px] md:text-[17px] leading-relaxed text-[#162028]/75 max-w-md">
              Empowering your brand journey with unparalleled marketing mastery — from cinematic launches to full-funnel digital storytelling.
            </p>
            <div className="flex flex-wrap gap-3">
              <a href="#services" className="inline-flex items-center gap-2 rounded-full bg-[#162028] px-5 py-3 text-[13.5px] font-semibold text-[#ede2c4] hover:bg-[#49001B] transition-colors group">
                Our Services
                <ArrowUpRight size={16} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a href="#gallery" className="inline-flex items-center gap-2 rounded-full border border-[#162028]/25 px-5 py-3 text-[13.5px] font-semibold text-[#162028] hover:bg-[#162028] hover:text-[#ede2c4] transition-colors">
                See Work
              </a>
            </div>
            <div className="flex items-center gap-4 pt-4 border-t border-[#162028]/10">
              <div className="flex -space-x-1.5">
                {[0,1,2,3,4].map((i) => (
                  <Star key={i} size={14} className="fill-[#49001B] text-[#49001B]" />
                ))}
              </div>
              <div className="text-[12px] leading-tight text-[#162028]/70">
                <div className="font-semibold text-[#162028]">50+ campaigns delivered</div>
                Trusted by Malayalam &amp; Tamil cinema
              </div>
            </div>
          </div>
        </div>

        {/* Big stat marquee band */}
        <div className="mt-14 md:mt-20 grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-2">
          {[
            { k: '50+', v: 'Film campaigns' },
            { k: '30+', v: 'Brand partners' },
            { k: '3', v: 'Verticals' },
            { k: '2022', v: 'Founded' },
          ].map((s, i) => (
            <div key={i} className="border-t border-[#162028]/15 pt-4">
              <div className="font-serif-display text-4xl md:text-5xl text-[#162028]">{s.k}</div>
              <div className="text-[12px] uppercase tracking-[0.2em] text-[#162028]/60 mt-1">{s.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
